<template>
  <div class="user-management">
    <cl-sb
      ref="child"
      :declareType="1"
      :vehicleType="1"
    />
  </div>
</template>

<script>
  import ClSb from "@/components/sbgl/clsb.vue";
  export default {
    name: "person-management",
    components: { ClSb },
    props: {},
    data() {
      return {
      };
    },
    methods: {
    },
    created() {
    },
  };
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/views/sbgl/qyjcsb.vue